import Vue from 'vue'
import Header from 'objects/header/header'
import Modal from 'objects/modal/modal'

import withRender from './warn-close-modal.html'
import './warn-close-modal.scss'

export default withRender(Vue.extend({
  name: 'WarnCloseModal',
  components: {
    'tt-header': Header,
    'tt-modal': Modal
  },
  methods: {
    close() {
      this.$emit('close')
    },
    closeParentModal() {
      this.$emit('closeParentModal')
    }
  },
  mounted() {
    this.$nextTick(() => this.$refs.returnBtn.$el.focus())
  }
}))
